import { CurrencyCentInput, FF, FieldSet, Hr, TextInput, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'

import { useAnnualReviewSalesDepositsContext } from '../../context/AnnualReviewSalesDepositsContext'

type QuarterInfoNumber = 1 | 2 | 3 | 4

const SpecificQuarterForm = ({ quarterNumber }: { quarterNumber: QuarterInfoNumber }) => {
  const { formApi } = useAnnualReviewSalesDepositsContext()

  return (
    <FieldSet legend={`Q${quarterNumber} info`}>
      <FormRow>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.label`}
            validators={{
              onChange: Validators.required.field
            }}
            children={(field) => <FF field={field} input={(p) => <TextInput {...p} />} label="Label" required />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.sales`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Sales" required />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.taxes`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Taxes" required />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.cash`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Cash Deposits" required />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.invoices`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Cash Invoices" required />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.transfers`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Internal Transfers" required />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.checks`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Checks & Remote Deposit" required />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.credit_debit`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Credit / Debit" required />
            )}
          />
        </Col>
        <Col>
          <formApi.Field
            name={`quarter${quarterNumber}Info.other`}
            validators={{
              onChange: ({ value }) => Validators.required.number()(value)
            }}
            children={(field) => (
              <FF field={field} input={(p) => <CurrencyCentInput {...p} />} label="Other" required />
            )}
          />
        </Col>
      </FormRow>
      <br />
      <Hr />
    </FieldSet>
  )
}

export const QuarterInfoSection = () => (
  <>
    <SpecificQuarterForm quarterNumber={1} />
    <SpecificQuarterForm quarterNumber={2} />
    <SpecificQuarterForm quarterNumber={3} />
    <SpecificQuarterForm quarterNumber={4} />
  </>
)
